import { VF_EDIT_TABLE } from 'AppSrc/core/components/forms/form-base-components/v-f-edit-table';
import {
  // INLINE_ERRORS,
  SILENT_ERRORS,
  // MODAL_ERRORS,
  // commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  CI_UNAVAILABILITY_SUMMARY,
} from 'AppSrc/core/components/forms/form-base-components/summary-components/modal-summary/ci-unavailability-summary';
import { CiUnavailabilityModal } from './ci-unavailability-modal';
import 'AppSrc/core/style/components/form/fields/ci-unavailability.css';

const fieldId = 'ci_unavailability';

const validator = (params) => {
  const {
    values,
  } = params;

  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  if (values) {
    const fieldValue = Object.values(values[fieldId].dataByFormSectionId).map((item) => item.dataByFieldId);
    // all answers' status need to be closed
    const hasNotAllAnswered = fieldValue.some((item) => item.status.value !== 'Closed');
    if (hasNotAllAnswered) {
    /* ADD ERRORS TO ERROR OBJECT */
      errors[SILENT_ERRORS].push('Please add Actual Start and End dates');
      // errors[INLINE_ERRORS].push('');
    }
  }


  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = null;

const vFParams = {
  // The modal to open
  ModalSection: CiUnavailabilityModal,
  // A summary section for the data entered in the modal
  /* NOTE: This may end up having to change to a key, ie, how we do fieldType so we can put it on the summary page */
  modalSummaryType: CI_UNAVAILABILITY_SUMMARY,
  modalErrorsTitle: 'Please enter Actual start and end date/time.',

};

const ciUnavailabilityItems = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_EDIT_TABLE,
};

export { ciUnavailabilityItems };
